import { Button } from '../primitives/Button/Button.types'

// Generic function to extract date from navigation actions
export const extractDateFromNavigationActions = (
  actions?: any[]
): string | null => {
  if (!actions) return null

  const navigationAction = actions.find(
    (action: any) => action.type === 'NAVIGATION'
  )

  if (!navigationAction?.data) return null

  const hasPath = (data: any): data is { path: string } => {
    return data && typeof data.path === 'string'
  }
  if (!hasPath(navigationAction.data)) return null

  const urlParams = new URLSearchParams(
    navigationAction.data.path.split('?')[1]
  )
  return urlParams.get('date')
}

export const extractDateFromButton = (button?: Button): string | null => {
  if (!button) return null
  return extractDateFromNavigationActions(button.attributes?.actions?.onClick)
}
